import request from '@/blocks/request';

export function getWechatShare(params) {
  return request({
    baseURL: process.env.VUE_APP_PANGKU_MERCHANT,
    url: '/jssdk',
    params,
  });
}
